
//NOTE, these are mymantl portfolio style endorsements of users for skills
//these are distinct from the OB 2.0 endorsement claims

var EndorsementCollection = function(options){
    var oThis = this;

    oThis.defaults = {
        portfolioid: null,
        collectionid: -1,
        params: null
    }

    oThis.settings = $.extend( {}, oThis.defaults, options );
    oThis.noncurated = oThis.settings.collectionid == 0;
    oThis.fullset = oThis.settings.collectionid == -1;
    oThis.bCanManage = mantl.userid == mantl.portfolio_user_user;
    oThis.Actions = Reflux.createActions(['fetchEndorsements']);
    oThis.containerID;
    oThis.modalsID = "endorsementsCollectionModal";
    oThis.msgStack = new MessageStack();
    oThis.createStore();

    oThis.handleStack = function(){
        oThis.msgStack.Display(); //should we put these in a program builder container?
        oThis.msgStack.Clear();
    }

    //Program Designer
    oThis.EndorsementCollection = createReactClass({
        mixins: [Reflux.connect(oThis.EndorsementStore, 'endorsements')],

        componentDidUpdate: function(){
            var $component = $(ReactDOM.findDOMNode(this));
        },

        render: function() {
            var oComponent = this;
            var emptyMsg = "No endorsements to display."

            if(this.state.endorsements){
                var endorsements = [];
                for(var i = 0; i < this.state.endorsements.items.length; i++){
                    var oItem = this.state.endorsements.items[i];
                    endorsements.push(<oThis.EndorsementCollectionItem item={oItem} key={oItem.id} />);
                }

                if(endorsements.length > 0){
                    hideOnboarding();
                    return (
                        <div className="portfolio-content-endorsements clearfix">
                            {endorsements}
                        </div>
                    );
                } else {
                    showOnboarding();
                    return (
                        <div className="portfolio-content-endorsements">
                            {/* <div className="alert alert--information text--xl"><h1 className="h3 text--center">{emptyMsg}</h1> <img src={mantl.static_url + "assets/images/icon-collection.svg" } className="image--onboarding" alt="Collection Image" /></div> */}
                        </div>
                    );
                }

            } else {
                return (
                    <div className="portfolio-content-endorsements">
                        <div className="spinner spinner--pulsing"><div className="spinner-ring"></div></div>
                    </div>
                );
            }

        }
    });

    oThis.EndorsementCollectionSkill = createReactClass({
        componentDidMount: function() {
            var $component = $(ReactDOM.findDOMNode(this));
            var oComponent = this;
        },

        componentDidUpdate: function() {
        },


        render: function() {
            var oComponent = this;
            return (
                <span className="flag flag--badged">{this.props.skill}</span>
            );

        }
    });


    //Set
    oThis.EndorsementCollectionItem = createReactClass({
        componentDidMount: function() {
            var $component = $(ReactDOM.findDOMNode(this));
            var oComponent = this;
            $('[data-popover="tooltip"]',$component).tooltip();
        },

        componentDidUpdate: function() {
        },

        handleViewClick: function(event) {
            var oComponent = this;
            event.preventDefault();

            //Build Modal
            httpGet(this.props.item.view_url,"text/html, */*").then(
                function(value) {
                    var response = value;

                    var $modal = buildModal(response,{
                        classes: 'modal modal--full modal--flat',
                        header: "View Endorsement"
                    });
                    $('body').append($modal);
                    $modal.on("modal:close",function(){
                        $modal.off("modal:close").remove();
                        oThis.Actions.fetchEndorsements();
                    })
                    $modal.openModal();
                })
            .catch(
                function(reason) {
                    console.error('Error loading badges view.', reason);
                    alertify.error('Unable to Open Work')
                });

        },

        handleEditClick: function(event) {
            var oComponent = this;
            event.preventDefault();
            event.stopPropagation();
            //Build Modal
            httpGet(this.props.item.edit_url).then(
                function(value) {
                    var response = value;

                    var $modal = buildModal(response,{
                        classes: 'modal modal--full',
                        header: "Manage Endorsement"
                    });
                    $('body').append($modal);
                    $modal.on("modal:close",function(){
                        $modal.off("modal:close").remove();
                        oThis.Actions.fetchEndorsements();
                    })
                    $modal.openModal();
                })
            .catch(
                function(reason) {
                    console.error('Error loading badges edit.', reason);
                    alertify.error('Unable to Open Work Editor')
                });
        },

        render: function() {
            var oComponent = this;

            return (

                <div className="card card--endorsement" onClick={this.handleViewClick}>
                    <div className="card-header">
                        <h3 className="h5 text--center">{this.props.item.endorser.full_name}</h3>
                    </div>

                    <div className="card-preview">
                        <img className="card-avatar" src={this.props.item.endorser.avatar} alt={"Profile Image for " + this.props.item.endorser.full_name} />
                        {(function(){
                            if (oComponent.props.item.endorser.professional_title) {
                                return (<small><i className="icon-id-card icon--larger"></i> {oComponent.props.item.endorser.professional_title}</small>);
                            }
                        })()}
                        <div className="card-description">
                            <p>{this.props.item.description}</p>
                        </div>
                    </div>

                    <div className="card-footer">
                        <span className="flag flag--large flag--badged">{this.props.item.skills.length} Skills Endorsed <i className="icon-check-circle-o icon--success icon--larger"></i></span>&nbsp;
                        {(function(){
                            if (oThis.bCanManage) {
                                return (
                                    <a href={oComponent.props.item.edit_url} onClick={oComponent.handleEditClick} className="button button--sm button--skinny button--pill button--success"><i className="icon-toggle-on"></i> Manage</a>
                                );
                            }
                        })()}
                        {/* <span className="flag flag--large flag--badged flag--muted">Endorsed Evidence <i className="icon-check-circle-o icon--success icon--larger"></i></span> */}
                    </div>
                </div>

            );

        }
    });


};

EndorsementCollection.prototype.renderCollection = function(containerID) {
    this.containerID = containerID;
    ReactDOM.render(<this.EndorsementCollection />, document.getElementById(this.containerID));
}

//REFLUX STORE
EndorsementCollection.prototype.createStore = function() {
    var oThis = this;

    oThis.EndorsementStore = Reflux.createStore({
        listenables: oThis.Actions,
        endorsements: {}, //badges store

        init: function() {
        },

        getInitialState: function() {
            this.onFetchEndorsements();
        },

        onFetchEndorsements: function() {
            var oStore = this;
            var endpoint;
            if(oThis.fullset){
                endpoint = buildRoute(mantlroutes.portfolio_endorsements,{ portfolioid: oThis.settings.portfolioid });
            } else if(oThis.noncurated){
                endpoint = buildRoute(mantlroutes.portfolio_noncurated_endorsements,{ portfolioid: oThis.settings.portfolioid });
            } else {
                endpoint = buildRoute(mantlroutes.portfolio_collection_endorsements,{ portfolioid: oThis.settings.portfolioid, collectionid: oThis.settings.collectionid });
            }
            if(oThis.settings.params != null){
                endpoint += formatParams(oThis.settings.params);
            }
            httpGet(endpoint).then(
                function(value) {
                    oStore.endorsements.items = JSON.parse(value);
                    oStore.trigger(oStore.endorsements);
                })
            .catch(
                function(reason) {
                    console.error('Error loading endorsements.', reason);
                    alertify.error('Unable to load endorsements.')
                });
        }
    });


}
